import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Redirect, Route, Switch, useHistory, useParams } from 'react-router-dom';
import { useFormStyles } from '../../styles/useFormStyles';
import {
  route,
  COMPANY_DETAILS_TABS,
  companyDetailsParameters,
  companyDetailsRoute,
} from '../../utils/routing';
import { ViziTab, ViziTabs } from '../../utils/ViziTabs';
import CompanyDetailsOverview from './CompanyDetailsOverview';
import CompanyDetailsWallets from './CompanyDetailsWallets';
import dashboardStore from '../../state/dashboardStore';
import { PAGES } from '../../components/main/MainComponent';

const CompanyDetails = observer(() => {
  const formClasses = useFormStyles();

  const { companyid } = useParams<{ companyid: string }>();

  const history = useHistory();

  useEffect(() => {
    dashboardStore.appBarLabel = 'Company details';
  }, [history.location]);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <div className={formClasses.root}>
          <div className={formClasses.verticalRoot}>
            <ViziTabs
              basePath={companyDetailsParameters(companyid)}
              tabs={Object.values(COMPANY_DETAILS_TABS)}
            >
              <ViziTab
                label={COMPANY_DETAILS_TABS.OVERVIEW}
                linkTo={companyDetailsParameters(companyid, COMPANY_DETAILS_TABS.OVERVIEW)}
              />
              <ViziTab
                label={COMPANY_DETAILS_TABS.WALLETS}
                linkTo={companyDetailsParameters(companyid, COMPANY_DETAILS_TABS.WALLETS)}
              />
            </ViziTabs>

            <Switch>
              <Route path={companyDetailsRoute(COMPANY_DETAILS_TABS.OVERVIEW)}>
                <CompanyDetailsOverview companyid={companyid} />
              </Route>
              <Route path={companyDetailsRoute(COMPANY_DETAILS_TABS.WALLETS)}>
                <CompanyDetailsWallets companyid={companyid} />
              </Route>
              <Route path={route(PAGES.Companies)}>
                <Redirect to={companyDetailsParameters(companyid, COMPANY_DETAILS_TABS.OVERVIEW)} />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
});

export default CompanyDetails;
